import React from 'react';

const SubTimelineConnector = () => (
  <svg
    width="33"
    height="19"
    viewBox="0 0 33 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    <path d="M0.5 0V10C0.5 14.4183 4.08172 18 8.5 18H32.5" stroke="#D0D7DE" />
  </svg>
);

export default SubTimelineConnector;
